import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => {
	return {
		userInfoIcon: {},
	};
};
